module.exports = __webpack_public_path__ + "static/media/vashet2.91ffc959.png";